import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import "../styles/pagination.css";

import Helmet from "../components/Helmet";
import CommonSection from "../components/CommonSection";
import { Container, Row } from "reactstrap";
import CarCard from "../components/CarCard";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  InfoWindow,
  Marker,
} from "react-google-maps";
import { useNavigate } from "react-router-dom";
import { getListings } from "../util/api";
import FullScreenLoader from "../components/FullScreenLoader";

const CarRental = () => {
  // const {
  //   data: carData,
  //   isPending,
  //   error,
  // } = useFetch(`${BASE_URL}api/Booking/get-listings`);

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const [pageNumber, setPageNumber] = useState(0);
  const [latLng, setlatLng] = useState("");
  const [lat, setLat] = useState("");
  const [lon, setLon] = useState("");
  const [carData, setCarData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (myParam == null) {
      getListings()
        .then((res) => {
          setCarData(res);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      getListings()
        .then((res) => {
          let arr = res.filter((e) => e.brandName == myParam);
          setCarData(arr);
          setLoading(false);
        })
        .catch((err) => setLoading(false));
    }
  }, []);

  const carPerPage = 6;
  const visitedPage = pageNumber * carPerPage;
  const displayPage = carData
    .slice(visitedPage, visitedPage + carPerPage)
    .map((item) => <CarCard item={item} />);

  const pageCount = Math.ceil(carData.length / carPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getLocation();
  }, [carData]);

  const navigate = useNavigate();

  const MyMapComponent = withScriptjs(
    withGoogleMap((props) => (
      <GoogleMap
        onClick={(e) => {
          setlatLng(e.latLng);
        }}
        defaultZoom={8}
        defaultCenter={{ lat: lat, lng: lon }}
      >
        {/* {props.isMarkerShown && <Marker position={{ lat: lat, lng: lon }} />} */}
        {carData.map((item, index) => (
          <Marker
            key={item.id}
            position={{
              lat: parseInt(item.latitude),
              lng: parseInt(item.longitude),
            }}
          >
            <InfoWindow>
              <div>
                {item.brandName + " " + item.carName}
                <button
                  onClick={() => {
                    navigate(`/car-details/${item.carListId}`);
                  }}
                >
                  Show details
                </button>
              </div>
            </InfoWindow>
          </Marker>
        ))}
      </GoogleMap>
    ))
  );
  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(success, locationerror);
    } else {
      console.log("Geolocation not supported");
    }
  };

  function success(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
    setLat(latitude);
    setLon(longitude);
  }

  function locationerror() {
    console.log("Unable to retrieve your location");
  }
  const urlSearchString = window.location.search;
  const params = new URLSearchParams(urlSearchString);
  const myParam = params.get("param");
  console.log(myParam);
  return (
    <Helmet title={myParam == null ? "Car-Listing" : myParam}>
      <section className="pt-0">
        <CommonSection title={myParam == null ? "Car-Listing" : myParam} />
      </section>
      <section className="pt-0">
        <Container>
          <Row>
            {/* {isPending && <h6 className="text-center">Loading......</h6>}
            {error && <h6 className="text-center">{error}</h6>} */}
            <div className=" d-flex align-items-center mb-5 gap-3 car__sorting">
              <Button onClick={toggle}>Map</Button>
              <Button onClick={toggle}>Filter</Button>
            </div>

            {displayPage}
            <div>
              <ReactPaginate
                previousLabel={"Prev"}
                nextLabel={"Next"}
                pageCount={pageCount}
                onPageChange={changePage}
                containerClassName="paginationBttns"
              />
            </div>
          </Row>
        </Container>
      </section>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Map</ModalHeader>
        <ModalBody>
          <div>
            <MyMapComponent
              isMarkerShown
              googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDf8vXaSoZYz_TQSWf1VmYrtw2TNOrEA_E&v=3.exp&libraries=geometry,drawing,places"
              // googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places"
              loadingElement={<div style={{ height: `100%` }} />}
              containerElement={
                <div style={{ height: `400px`, width: "470px" }} />
              }
              mapElement={<div style={{ height: `100%` }} />}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      {loading ? <FullScreenLoader /> : null}
    </Helmet>
  );
};

export default CarRental;
